import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function VerifyAccount() {
  useEffect(() => {
    document.title = 'Account verification | PromptSlate';
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const emailParam = queryParams.get('email');
    const tokenParam = queryParams.get('token');

    if (!emailParam || !tokenParam) {
      setErrorMessage('Missing verification data');
    } else {
      handleAccountVerification(emailParam, tokenParam);
    }
  }, []);

  const handleAccountVerification = async (email: string, token: string) => {
    setErrorMessage('');

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify`, {
        email,
        token,
      });

      navigate('/login');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error response from the server
        setErrorMessage(error.response.data.message || 'Something went wrong!');
      } else {
        // Network or unknown error
        setErrorMessage('An unknown error occurred.');
      }
    }
  };

  return (
    <div className="flex flex-row items-center justify-center h-screen bg-[#f8f7f2]">
      {errorMessage}
    </div>
  );
}

export default VerifyAccount;
